import { Modal, Button, notification } from 'antd'
import axios, { all } from 'axios'
import React, { useState } from 'react'
import baseUrl, { betaBaseUrl } from '../../config';
import { CheckCircleTwoTone, SyncOutlined, WarningTwoTone } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const AddConstraint = ({
    modalOpen,
    setModalOpen,
    modifiedData,
    modifiedData1,
    modifiedData2,
    modifiedData3,
    modifiedData4,
    refresh,
    setRefresh,
    isBeta
}) => {
    const { t } = useTranslation();
    const [colors, setColors] = useState("#52c41a");

    const [allData, setAllData] = useState({
        number: "",
        code: "",
        isChecked: false,
        panelType: "",
        group: false
    })

    const [api, contextHolder] = notification.useNotification();
    const openNotification = (placement, value, icon) => {
        api.info({
            message: t('constraint.systemInfo'),
            description: `${value}`,
            placement,
            icon: icon || <CheckCircleTwoTone twoToneColor="#52c41a" />,
        });
    };

    const handleChange = (e) => {
        if (e.target.name === "group") {
            setAllData({ ...allData, isChecked: !allData.isChecked });
        } else {
            setAllData({ ...allData, [e.target.name]: e.target.value });
        }
    }


    const handleSubmit = (e) => {
        e.preventDefault()
        // API endpoint'ini ortama göre ayarla
        const apiEndpoint = isBeta ? `${betaBaseUrl}/addPanel` : `${baseUrl}/addPanel`;
        
        axios.post(apiEndpoint, ({ panelType: allData.panelType, code: allData.code, number: allData.isChecked === true ? "" : allData.number, type: colors }))
            .then(res => {
                if (res.status === 200) {
                    setModalOpen(false)
                    openNotification('top', 'Gönderildi')
                    setAllData({
                        number: "",
                        code: "",
                        isChecked: false,
                        panelType: "",
                        group: false
                    })
                    setColors("")
                    setRefresh(!refresh)
                }
                if (res.status === 201) {
                    openNotification('top', res.data, <WarningTwoTone twoToneColor="red" />)
                }
            });
    }


    // uniq renkleri al

    let uniqueNumbers = [];

    switch (allData.panelType) {
        case "rearPanel":
            if (modifiedData) {
                const allNumbers = modifiedData.reduce((acc, item) => {
                    const number = item.number;
                    if (number) {
                        acc.add(number);
                    }
                    return acc;
                }, new Set());
                uniqueNumbers = Array.from(allNumbers);
            }
            break;
        case "kapiIcSac":
            if (modifiedData1) {
                const allNumbers1 = modifiedData1.reduce((acc, item) => {
                    const number = item.number;
                    if (number) {
                        acc.add(number);
                    }
                    return acc;
                }, new Set());
                uniqueNumbers = Array.from(allNumbers1);
            }
            break;
        case "topBottom":
            if (modifiedData2) {
                const allNumbers2 = modifiedData2.reduce((acc, item) => {
                    const number = item.number;
                    if (number) {
                        acc.add(number);
                    }
                    return acc;
                }, new Set());
                uniqueNumbers = Array.from(allNumbers2);
            }
            break;
        case "sidePanel":
            if (modifiedData3) {
                const allNumbers3 = modifiedData3.reduce((acc, item) => {
                    const number = item.number;
                    if (number) {
                        acc.add(number);
                    }
                    return acc;
                }, new Set());
                uniqueNumbers = Array.from(allNumbers3);
            }
            break;
        case "backPanel":
            if (modifiedData4) {
                const allNumbers4 = modifiedData4.reduce((acc, item) => {
                    const number = item.number;
                    if (number) {
                        acc.add(number);
                    }
                    return acc;
                }, new Set());
                uniqueNumbers = Array.from(allNumbers4);
            }
            break;
        default:
        // code block
    }

    // const uniqueNumbers = Array.from(allNumbers);
    const columnsData = ["Rear Panel", "KapI İç Sac", "Top Bottom", "Side Panel", "Back Panel"]
    return (
        <>
            {contextHolder}

            <Modal
                title={`${t('constraint.addPanel')} ${isBeta ? '(Beta)' : ''}`}
                centered
                open={modalOpen}
                onCancel={() => {
                    setAllData({
                        number: "",
                        code: "",
                        isChecked: false,
                        panelType: "",
                        group: false
                    })
                    setColors("")
                    setModalOpen(false)
                }}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
            >

                <form onSubmit={handleSubmit}>
                    <div className='w-full flex flex-col gap-10 justify-center mt-8'>

                        <div className='flex'>
                            <label className='flex w-32 mt-1'>{t('constraint.panelCode')} : </label>
                            <input required type='number' onChange={handleChange} name="code" placeholder={t('constraint.enterPanelCode')} value={allData.code} className='border border-solid border-borderColor rounded-lg  h-33px w-full' />
                        </div>
                        <div className='flex'>
                            <label className='flex w-32 mt-1'>{t('constraint.panelType')} : </label>
                            <select onChange={handleChange} name="panelType" value={allData.panelType} className='border border-solid border-borderColor rounded-lg w-full h-33px'>
                                <option value="">{t('constraint.select')}</option>
                                {
                                    columnsData.map((item, index) => {
                                        return (
                                            <option key={index}
                                                value={item === "KapI İç Sac" && "kapiIcSac" || item === "Rear Panel" && "rearPanel" || item === "Top Bottom" && "topBottom" || item === "Side Panel" && "sidePanel" || item === "Back Panel" && "backPanel"}
                                                className={item}>{t(`constraint.panels.${item.toLowerCase().replace(' ', '')}`)}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        {
                            allData.isChecked === false ?
                                <div className='flex'>
                                    <label className='flex w-32 mt-1'>{t('constraint.number')} : </label>
                                    <select required={allData.isChecked === false} onChange={handleChange} name="number" value={allData.number} className='border border-solid border-borderColor rounded-lg w-full h-33px'>
                                        <option value="">{t('constraint.select')}</option>
                                        {
                                            uniqueNumbers.map((item, index) => {
                                                return (
                                                    <option key={index} value={item} className={item}>{item}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                : null
                        }

                        <div className='flex items-center gap-20'>
                            <div className='flex flex-row'>
                                <label className='flex w-32 mt-1'>{t('constraint.addGroup')} : </label>
                                <input type='checkbox' onChange={handleChange} name="group" checked={allData.isChecked} className='border border-solid border-borderColor rounded-lg w-full h-33px' />
                            </div>
                            {allData.isChecked ?
                                <div className='flex flex-row'>
                                    <label className='flex w-32 mt-1'>{t('constraint.addNewColor')}: </label>
                                    <input className='flex w-28 h-10' type="color" value={colors} onChange={e => setColors(e.target.value)} />
                                </div>
                                : null
                            }


                        </div>

                        <div className='w-full flex flex-col gap-3 justify-center mt-8'>
                            <Button type='submit' htmlType='submit' className='flex justify-center items-center bg-smartoptLogoColor text-white font-bold text-base '>{t('constraint.submit')}</Button>
                        </div>

                    </div>
                </form>
            </Modal>
        </>
    )
}

export default AddConstraint